import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import type { TriggerProps } from '@atlaskit/popup';
import { Box, Pressable } from '@atlaskit/primitives/compiled';

import type { TriggerMode } from '../../popup-adapter/PopupTriggerWithHover';

const styles = cssMap({
	trigger: {
		all: 'unset',
		display: 'inline',
	},
});

type UserProfileCardTriggerProps = {
	/** Resolved by {@link UserProfileCardWithTrigger} (defaults to `'click'` when that prop is omitted). */
	trigger: TriggerMode;
	triggerProps: TriggerProps;
	children: ReactNode;
};

export const UserProfileCardTrigger = ({
	trigger,
	triggerProps,
	children,
}: UserProfileCardTriggerProps): React.JSX.Element => {
	const hoverOnlyTrigger = Array.isArray(trigger)
		? trigger.every((mode) => mode === 'hover')
		: trigger === 'hover';
	const useNonInteractiveHoverTrigger = hoverOnlyTrigger;

	if (useNonInteractiveHoverTrigger) {
		const { 'aria-expanded': _ariaExpanded, ...nonDialogTriggerProps } = triggerProps;

		return (
			<Box
				as="span"
				{...nonDialogTriggerProps}
				testId="user-profile-card-trigger-wrapper"
				xcss={styles.trigger}
			>
				{children}
			</Box>
		);
	}

	return (
		<Pressable {...triggerProps} testId="user-profile-card-trigger-wrapper" xcss={styles.trigger}>
			{children}
		</Pressable>
	);
};
